import React, { memo } from 'react';

const ConteragentInner = () => (
    <svg viewBox="0 0 18 18">
        <path d="M0 0V2H9V12H0V14H7V16C7 17.105 7.895 18 9 18H18V16H9V14C10.105 14 11 13.105 11 12V6H18V4H11V2C11 0.895 10.105 0 9 0H0ZM3 4V6H0V8H3V10L6 7L3 4ZM15 8L12 11L15 14V12H18V10H15V8Z" />
    </svg>
);

export const Conteragent = memo(ConteragentInner);
